'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  background: ', ';\n\n\n  td {\n    padding: 4px 0;\n    vertical-align: top;\n  }\n\n  td.table-data-no-pointer {\n    cursor: default;\n  }\n\n\n  thead {\n    background: ', ';\n    font-family: ', ';\n    th {\n      color: ', ';\n      padding: 10px 8px;\n\n        &:first-child {\n          text-align: left;\n        }\n    }\n\n    .table-header {\n       text-align: center;\n    }\n\n   .table-header-left {\n      text-align: left;\n    }\n\n    .table-header-right {\n      text-align: right;\n    }\n  }\n\n  tbody {\n    tr{\n      &:nth-child(even) {\n        background: #FAFAFA;\n      }\n      border-top: 1px solid ', ';\n      &:hover {\n        color: ', ';\n        cursor: pointer;\n      }\n\n      td {\n        max-width: 200px;\n        padding: 19px 8px;\n\n         &:first-child {\n          text-align: left;\n        }\n      }\n\n      .table-data-align-left {\n        text-align: left;\n      }\n\n      .table-data-align-right {\n        text-align: right;\n      }\n\n      .table-data-align-center {\n        text-align: center;\n      }\n\n      &:last-child {\n         border-bottom: 1px solid ', ';\n      }\n    }\n\n    tr.odd {\n        background: #FAFAFA;\n      }\n\n     tr.even {\n      background: ', ';\n\n     }\n\n     tr.noBorder {\n      border-top: 0px;\n     }\n  }\n\n\n  .table-totals {\n    color: ', ';\n    .table-data {\n      font-family: ', ';\n    }\n  }\n\n  .table-data-total {\n    color: ', ';\n  }\n\n  .table-data-highlight {\n    color: ', ';\n  }\n\n  .table-data-hightlight-notification {\n     color: ', ';\n\n     svg {\n      fill: ', ' !important;\n     }\n  }\n\n  .table-data-hightlight-negative {\n    color: ', ';\n  }\n\n  .table-data-bold {\n    font-family: ', ';\n  }\n\n  .table-data-primitive-cell {\n    font-size: ', 'px;\n    color: ', ';\n    opacity: 0.5;\n    text-align: right;\n  }\n\n  .no-padding-top {\n    padding-top: 0px;\n  }\n\n'], ['\n  width: 100%;\n  background: ', ';\n\n\n  td {\n    padding: 4px 0;\n    vertical-align: top;\n  }\n\n  td.table-data-no-pointer {\n    cursor: default;\n  }\n\n\n  thead {\n    background: ', ';\n    font-family: ', ';\n    th {\n      color: ', ';\n      padding: 10px 8px;\n\n        &:first-child {\n          text-align: left;\n        }\n    }\n\n    .table-header {\n       text-align: center;\n    }\n\n   .table-header-left {\n      text-align: left;\n    }\n\n    .table-header-right {\n      text-align: right;\n    }\n  }\n\n  tbody {\n    tr{\n      &:nth-child(even) {\n        background: #FAFAFA;\n      }\n      border-top: 1px solid ', ';\n      &:hover {\n        color: ', ';\n        cursor: pointer;\n      }\n\n      td {\n        max-width: 200px;\n        padding: 19px 8px;\n\n         &:first-child {\n          text-align: left;\n        }\n      }\n\n      .table-data-align-left {\n        text-align: left;\n      }\n\n      .table-data-align-right {\n        text-align: right;\n      }\n\n      .table-data-align-center {\n        text-align: center;\n      }\n\n      &:last-child {\n         border-bottom: 1px solid ', ';\n      }\n    }\n\n    tr.odd {\n        background: #FAFAFA;\n      }\n\n     tr.even {\n      background: ', ';\n\n     }\n\n     tr.noBorder {\n      border-top: 0px;\n     }\n  }\n\n\n  .table-totals {\n    color: ', ';\n    .table-data {\n      font-family: ', ';\n    }\n  }\n\n  .table-data-total {\n    color: ', ';\n  }\n\n  .table-data-highlight {\n    color: ', ';\n  }\n\n  .table-data-hightlight-notification {\n     color: ', ';\n\n     svg {\n      fill: ', ' !important;\n     }\n  }\n\n  .table-data-hightlight-negative {\n    color: ', ';\n  }\n\n  .table-data-bold {\n    font-family: ', ';\n  }\n\n  .table-data-primitive-cell {\n    font-size: ', 'px;\n    color: ', ';\n    opacity: 0.5;\n    text-align: right;\n  }\n\n  .no-padding-top {\n    padding-top: 0px;\n  }\n\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\n\n  tbody {\n    tr{\n      td {\n        text-align: center;\n        &:first-child {\n          font-family: ', ';\n          color: ', ';\n          text-align: ', ';\n        }\n      }\n    }\n\n    td.table-data-strong {\n      span {\n        font-family: ', ';\n        color: ', ';\n      }\n    }\n  }\n\n'], ['\n\n\n  tbody {\n    tr{\n      td {\n        text-align: center;\n        &:first-child {\n          font-family: ', ';\n          color: ', ';\n          text-align: ', ';\n        }\n      }\n    }\n\n    td.table-data-strong {\n      span {\n        font-family: ', ';\n        color: ', ';\n      }\n    }\n  }\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Table = _styledComponents2.default.table(_templateObject, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.primary;
}, function (props) {
  return props.theme.color.notification;
}, function (props) {
  return props.theme.color.notification;
}, function (props) {
  return props.theme.color.negative;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.size["4"];
}, function (props) {
  return props.theme.color.base2;
});

Table.displayName = 'Table';
var HighlightTable = (0, _styledComponents2.default)(Table)(_templateObject2, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.highlightAlignCenter ? "center" : "left";
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.base2;
});

// const StaticHeaderWrapper = styled.section`
//   position: relative;
//   padding-top: 41px;
//   background: ${props => props.theme.color.secondary};
// `;
//
// const StaticHeader = styled.div`
//   max-height: 500px;
//   overflow: auto;
//
//   .table {
//     margin-bottom: 0;
//     .table-header {
//       height: 0;
//       line-height: 0;
//       padding-top: 0;
//       padding-bottom: 0;
//       color: transparent;
//       border: none;
//       white-space: nowrap;
//
//       .table-static-header {
//         position: absolute;
//         background: transparent;
//         color: ${props => props.theme.color.white};
//         padding: 10px 0;
//         top: 0;
//         line-height: normal;
//
//       }
//     }
//
//   }
// `;

HighlightTable.displayName = 'HighlightTable';
var NitroTable = function NitroTable(_ref) {
  var className = _ref.className,
      children = _ref.children,
      highlighted = _ref.highlighted,
      staticHeader = _ref.staticHeader,
      highlightAlignCenter = _ref.highlightAlignCenter;

  // const tableClass = cx([
  //   'table',
  //   {
  //     'table-highlight': highlighted
  //   }
  // ]);

  // if (staticHeader) {
  //   return (
  //     <StaticHeaderWrapper>
  //       <StaticHeader>
  //         <table className={tableClass}>
  //           {children}
  //         </table>
  //       </StaticHeader>
  //     </StaticHeaderWrapper>
  //   );
  // }

  if (highlighted) {
    return _react2.default.createElement(
      HighlightTable,
      {
        className: className,
        highlightAlignCenter: highlightAlignCenter
      },
      children
    );
  }

  return _react2.default.createElement(
    Table,
    { className: className },
    children
  );
};

NitroTable.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  highlighted: _propTypes2.default.bool,
  staticHeader: _propTypes2.default.bool,
  highlightAlignCenter: _propTypes2.default.bool
};

exports.default = NitroTable;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-table/NitroTable.js
// module id = 3039
// module chunks = 4